import { useState } from "react";
import { readJson, writeJson } from "../lib/storage";

const STORAGE_KEY = "townsy.walkKeysHint.collapsed";

/**
 * Keyboard controls in Walk mode, on screen (founder 2026-10-14: "in the main town when you are walking how can you
 * run?"): walk with W A S D or the arrows, hold Shift to run (ADR-0018), E to go in or sit. Touch screens have the
 * joystick and the Run button instead. × collapses it to a small "Keys" button; the choice is remembered on this
 * device only.
 */
export function WalkKeysHint() {
  const [collapsed, setCollapsed] = useState(() => readJson<boolean>("local", STORAGE_KEY) === true);
  const toggle = (next: boolean) => {
    setCollapsed(next);
    writeJson("local", STORAGE_KEY, next);
  };
  if (collapsed) {
    return (
      <button type="button" className="walk-keys-chip" onClick={() => toggle(false)} title="Show the walking keys" data-testid="walk-keys-show">
        Keys
      </button>
    );
  }
  return (
    <div className="walk-keys" role="note" aria-label="Walking keys" data-testid="walk-keys">
      <span>
        <kbd>W</kbd>
        <kbd>A</kbd>
        <kbd>S</kbd>
        <kbd>D</kbd> walk
      </span>
      <span>
        hold <kbd>Shift</kbd> run
      </span>
      <span>
        <kbd>E</kbd> go in / sit
      </span>
      <button type="button" className="walk-keys-hide" onClick={() => toggle(true)} aria-label="Hide the walking keys" title="Hide" data-testid="walk-keys-hide">
        ×
      </button>
    </div>
  );
}
